import { j as I } from "../../jsx-runtime-B6kdoens.js";
import h, { useState as le, createContext as Bt, useMemo as We, useCallback as X, useEffect as jt } from "react";
import { d as qt } from "../../index-CROKJrb5.js";
import { ChevronIcon as Te } from "../Icon/icons/ChevronIcon/index.js";
var k;
(function(e) {
  e.ButtonPrevious = "button_previous", e.ButtonNext = "button_next", e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(k || (k = {}));
var x;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(x || (x = {}));
var _;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(_ || (_ = {}));
function Ht(e, t, n = {}) {
  return Object.entries(e).filter(([, a]) => a === !0).reduce((a, [o]) => (n[o] ? a.push(n[o]) : t[x[o]] ? a.push(t[x[o]]) : t[_[o]] && a.push(t[_[o]]), a), [t[k.Day]]);
}
function At(e) {
  return h.createElement("button", { ...e });
}
function It(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return h.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && h.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && h.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && h.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && h.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" })
  );
}
function Rt(e) {
  return h.createElement("span", { ...e });
}
function Gt(e) {
  const { day: t, modifiers: n, ...r } = e;
  return h.createElement("td", { ...r });
}
function Lt(e) {
  const { day: t, modifiers: n, ...r } = e, a = h.useRef(null);
  return h.useEffect(() => {
    var o;
    n.focused && ((o = a.current) == null || o.focus());
  }, [n.focused]), h.createElement("button", { ref: a, ...r });
}
function Qt(e) {
  const { options: t, className: n, components: r, classNames: a, ...o } = e, s = [a[k.Dropdown], n].join(" "), i = t == null ? void 0 : t.find(({ value: u }) => u === o.value);
  return h.createElement(
    "span",
    { "data-disabled": o.disabled, className: a[k.DropdownRoot] },
    h.createElement(r.Select, { className: s, ...o }, t == null ? void 0 : t.map(({ value: u, label: d, disabled: l }) => h.createElement(r.Option, { key: u, value: u, disabled: l }, d))),
    h.createElement(
      "span",
      { className: a[k.CaptionLabel], "aria-hidden": !0 },
      i == null ? void 0 : i.label,
      h.createElement(r.Chevron, { orientation: "down", size: 18, className: a[k.Chevron] })
    )
  );
}
function Xt(e) {
  return h.createElement("div", { ...e });
}
function $t(e) {
  return h.createElement("div", { ...e });
}
function Vt(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return h.createElement("div", { ...r }, e.children);
}
function zt(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return h.createElement("div", { ...r });
}
function Jt(e) {
  return h.createElement("table", { ...e });
}
function Kt(e) {
  return h.createElement("div", { ...e });
}
function Zt(e) {
  return h.createElement("nav", { ...e });
}
function Ut(e) {
  return h.createElement("option", { ...e });
}
function en(e) {
  return h.createElement("div", { ...e });
}
function tn(e) {
  return h.createElement("select", { ...e });
}
function nn(e) {
  return h.createElement("tbody", { ...e });
}
function rn(e) {
  const { week: t, ...n } = e;
  return h.createElement("tr", { ...n });
}
function an(e) {
  return h.createElement("th", { ...e });
}
function on(e) {
  return h.createElement(
    "thead",
    null,
    h.createElement("tr", { ...e })
  );
}
function sn(e) {
  const { week: t, ...n } = e;
  return h.createElement("td", { ...n });
}
function cn(e) {
  return h.createElement("th", { ...e });
}
const un = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: At,
  CaptionLabel: Rt,
  Chevron: It,
  Day: Gt,
  DayButton: Lt,
  Dropdown: Qt,
  DropdownNav: Xt,
  Footer: $t,
  Month: Vt,
  MonthCaption: zt,
  MonthGrid: Jt,
  Months: Kt,
  Nav: Zt,
  Option: Ut,
  Root: en,
  Select: tn,
  Week: rn,
  WeekNumber: sn,
  WeekNumberHeader: cn,
  Weekday: an,
  Weekdays: on,
  Weeks: nn
}, Symbol.toStringTag, { value: "Module" }));
function dn(e) {
  return {
    ...un,
    ...e
  };
}
function fn(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function O(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function j(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function He(e, t) {
  const n = O(e);
  return isNaN(t) ? j(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function oe(e, t) {
  const n = O(e);
  if (isNaN(t)) return j(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), a = j(e, n.getTime());
  a.setMonth(n.getMonth() + t + 1, 0);
  const o = a.getDate();
  return r >= o ? a : (n.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    r
  ), n);
}
function ln(e, t) {
  const n = t * 7;
  return He(e, n);
}
function he(e, t) {
  return oe(e, t * 12);
}
const Ae = 6048e5, hn = 864e5;
function se(e) {
  const t = O(e);
  return t.setHours(0, 0, 0, 0), t;
}
function _e(e) {
  const t = O(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Ie(e, t) {
  const n = se(e), r = se(t), a = +n - _e(n), o = +r - _e(r);
  return Math.round((a - o) / hn);
}
function mn(e, t) {
  const n = O(e), r = O(t), a = n.getFullYear() - r.getFullYear(), o = n.getMonth() - r.getMonth();
  return a * 12 + o;
}
let gn = {};
function ce() {
  return gn;
}
function Re(e, t) {
  var i, u, d, l;
  const n = ce(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : u.weekStartsOn) ?? n.weekStartsOn ?? ((l = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = O(e), o = a.getDay(), s = (o < r ? -7 : 0) + 6 - (o - r);
  return a.setDate(a.getDate() + s), a.setHours(23, 59, 59, 999), a;
}
function yn(e) {
  return Re(e, { weekStartsOn: 1 });
}
function bn(e) {
  const t = O(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function wn(e) {
  const t = O(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
const Mn = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, kn = (e, t, n) => {
  let r;
  const a = Mn[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Ne(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Dn = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, On = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Wn = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Nn = {
  date: Ne({
    formats: Dn,
    defaultWidth: "full"
  }),
  time: Ne({
    formats: On,
    defaultWidth: "full"
  }),
  dateTime: Ne({
    formats: Wn,
    defaultWidth: "full"
  })
}, vn = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, xn = (e, t, n, r) => vn[e];
function re(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : s;
      a = e.formattingValues[i] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, i = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[i] || e.values[s];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[o];
  };
}
const Sn = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Pn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Yn = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Cn = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, En = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Tn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, _n = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Fn = {
  ordinalNumber: _n,
  era: re({
    values: Sn,
    defaultWidth: "wide"
  }),
  quarter: re({
    values: Pn,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: re({
    values: Yn,
    defaultWidth: "wide"
  }),
  day: re({
    values: Cn,
    defaultWidth: "wide"
  }),
  dayPeriod: re({
    values: En,
    defaultWidth: "wide",
    formattingValues: Tn,
    defaultFormattingWidth: "wide"
  })
};
function ae(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    const s = o[0], i = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(i) ? Bn(i, (m) => m.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      pn(i, (m) => m.test(s))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(u) : u, d = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(d)
    ) : d;
    const l = t.slice(s.length);
    return { value: d, rest: l };
  };
}
function pn(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Bn(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function jn(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let s = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const i = t.slice(a.length);
    return { value: s, rest: i };
  };
}
const qn = /^(\d+)(th|st|nd|rd)?/i, Hn = /\d+/i, An = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, In = {
  any: [/^b/i, /^(a|c)/i]
}, Rn = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Gn = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ln = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Qn = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Xn = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $n = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Vn = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, zn = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Jn = {
  ordinalNumber: jn({
    matchPattern: qn,
    parsePattern: Hn,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ae({
    matchPatterns: An,
    defaultMatchWidth: "wide",
    parsePatterns: In,
    defaultParseWidth: "any"
  }),
  quarter: ae({
    matchPatterns: Rn,
    defaultMatchWidth: "wide",
    parsePatterns: Gn,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ae({
    matchPatterns: Ln,
    defaultMatchWidth: "wide",
    parsePatterns: Qn,
    defaultParseWidth: "any"
  }),
  day: ae({
    matchPatterns: Xn,
    defaultMatchWidth: "wide",
    parsePatterns: $n,
    defaultParseWidth: "any"
  }),
  dayPeriod: ae({
    matchPatterns: Vn,
    defaultMatchWidth: "any",
    parsePatterns: zn,
    defaultParseWidth: "any"
  })
}, Ge = {
  code: "en-US",
  formatDistance: kn,
  formatLong: Nn,
  formatRelative: xn,
  localize: Fn,
  match: Jn,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Le(e) {
  const t = O(e), n = j(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Kn(e) {
  const t = O(e);
  return Ie(t, Le(t)) + 1;
}
function ee(e, t) {
  var i, u, d, l;
  const n = ce(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : u.weekStartsOn) ?? n.weekStartsOn ?? ((l = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = O(e), o = a.getDay(), s = (o < r ? 7 : 0) + o - r;
  return a.setDate(a.getDate() - s), a.setHours(0, 0, 0, 0), a;
}
function ie(e) {
  return ee(e, { weekStartsOn: 1 });
}
function Qe(e) {
  const t = O(e), n = t.getFullYear(), r = j(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const a = ie(r), o = j(e, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = ie(o);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function Zn(e) {
  const t = Qe(e), n = j(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), ie(n);
}
function Xe(e) {
  const t = O(e), n = +ie(t) - +Zn(t);
  return Math.round(n / Ae) + 1;
}
function $e(e, t) {
  var l, m, y, M;
  const n = O(e), r = n.getFullYear(), a = ce(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((m = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : m.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((M = (y = a.locale) == null ? void 0 : y.options) == null ? void 0 : M.firstWeekContainsDate) ?? 1, s = j(e, 0);
  s.setFullYear(r + 1, 0, o), s.setHours(0, 0, 0, 0);
  const i = ee(s, t), u = j(e, 0);
  u.setFullYear(r, 0, o), u.setHours(0, 0, 0, 0);
  const d = ee(u, t);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= d.getTime() ? r : r - 1;
}
function Un(e, t) {
  var i, u, d, l;
  const n = ce(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : u.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((l = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, a = $e(e, t), o = j(e, 0);
  return o.setFullYear(a, 0, r), o.setHours(0, 0, 0, 0), ee(o, t);
}
function Ve(e, t) {
  const n = O(e), r = +ee(n, t) - +Un(n, t);
  return Math.round(r / Ae) + 1;
}
function N(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const $ = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return N(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : N(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return N(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return N(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return N(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return N(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return N(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return N(a, t.length);
  }
}, Z = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Fe = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return $.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = $e(e, r), o = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const s = o % 100;
      return N(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : N(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Qe(e);
    return N(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return N(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return N(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return N(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return $.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return N(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = Ve(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : N(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Xe(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : N(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : $.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Kn(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : N(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return N(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return N(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return N(a, t.length);
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = Z.noon : r === 0 ? a = Z.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = Z.evening : r >= 12 ? a = Z.afternoon : r >= 4 ? a = Z.morning : a = Z.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return $.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : $.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : N(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : N(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : $.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : $.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return $.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return Be(r);
      case "XXXX":
      case "XX":
        return z(r);
      case "XXXXX":
      case "XXX":
      default:
        return z(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Be(r);
      case "xxxx":
      case "xx":
        return z(r);
      case "xxxxx":
      case "xxx":
      default:
        return z(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + pe(r, ":");
      case "OOOO":
      default:
        return "GMT" + z(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + pe(r, ":");
      case "zzzz":
      default:
        return "GMT" + z(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return N(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return N(r, t.length);
  }
};
function pe(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(a) : n + String(a) + t + N(o, 2);
}
function Be(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + N(Math.abs(e) / 60, 2) : z(e, t);
}
function z(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = N(Math.trunc(r / 60), 2), o = N(r % 60, 2);
  return n + a + t + o;
}
const je = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, ze = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, er = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return je(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", je(r, t)).replace("{{time}}", ze(a, t));
}, tr = {
  p: ze,
  P: er
}, nr = /^D+$/, rr = /^Y+$/, ar = ["D", "DD", "YY", "YYYY"];
function or(e) {
  return nr.test(e);
}
function sr(e) {
  return rr.test(e);
}
function ir(e, t, n) {
  const r = cr(e, t, n);
  if (console.warn(r), ar.includes(e)) throw new RangeError(r);
}
function cr(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function Je(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ur(e) {
  if (!Je(e) && typeof e != "number")
    return !1;
  const t = O(e);
  return !isNaN(Number(t));
}
const dr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, lr = /^'([^]*?)'?$/, hr = /''/g, mr = /[a-zA-Z]/;
function J(e, t, n) {
  var l, m, y, M, g, b, f, w;
  const r = ce(), a = (n == null ? void 0 : n.locale) ?? r.locale ?? Ge, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((m = (l = n == null ? void 0 : n.locale) == null ? void 0 : l.options) == null ? void 0 : m.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((M = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : M.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((b = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : b.weekStartsOn) ?? r.weekStartsOn ?? ((w = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : w.weekStartsOn) ?? 0, i = O(e);
  if (!ur(i))
    throw new RangeError("Invalid time value");
  let u = t.match(fr).map((D) => {
    const c = D[0];
    if (c === "p" || c === "P") {
      const W = tr[c];
      return W(D, a.formatLong);
    }
    return D;
  }).join("").match(dr).map((D) => {
    if (D === "''")
      return { isToken: !1, value: "'" };
    const c = D[0];
    if (c === "'")
      return { isToken: !1, value: gr(D) };
    if (Fe[c])
      return { isToken: !0, value: D };
    if (c.match(mr))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + c + "`"
      );
    return { isToken: !1, value: D };
  });
  a.localize.preprocessor && (u = a.localize.preprocessor(i, u));
  const d = {
    firstWeekContainsDate: o,
    weekStartsOn: s,
    locale: a
  };
  return u.map((D) => {
    if (!D.isToken) return D.value;
    const c = D.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && sr(c) || !(n != null && n.useAdditionalDayOfYearTokens) && or(c)) && ir(c, t, String(e));
    const W = Fe[c[0]];
    return W(i, c, a.localize, d);
  }).join("");
}
function gr(e) {
  const t = e.match(lr);
  return t ? t[1].replace(hr, "'") : e;
}
function yr(e, t) {
  const n = O(e), r = O(t);
  return n.getTime() > r.getTime();
}
function br(e, t) {
  const n = O(e), r = O(t);
  return +n < +r;
}
function wr(e, t) {
  const n = se(e), r = se(t);
  return +n == +r;
}
function Mr(e, t) {
  const n = O(e), r = O(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function kr(e, t) {
  const n = O(e), r = O(t);
  return n.getFullYear() === r.getFullYear();
}
function Dr(e) {
  let t;
  return e.forEach(function(n) {
    const r = O(n);
    (t === void 0 || t < r || isNaN(Number(r))) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function Or(e) {
  let t;
  return e.forEach((n) => {
    const r = O(n);
    (!t || t > r || isNaN(+r)) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function Wr(e) {
  const t = O(e), n = t.getFullYear(), r = t.getMonth(), a = j(e, 0);
  return a.setFullYear(n, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function Nr(e, t) {
  const n = O(e), r = n.getFullYear(), a = n.getDate(), o = j(e, 0);
  o.setFullYear(r, t, 15), o.setHours(0, 0, 0, 0);
  const s = Wr(o);
  return n.setMonth(t, Math.min(a, s)), n;
}
function vr(e, t) {
  const n = O(e);
  return isNaN(+n) ? j(e, NaN) : (n.setFullYear(t), n);
}
function xr(e) {
  const t = O(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
const A = {
  /** The constructor of the date object. */
  Date,
  addDays: He,
  addMonths: oe,
  addWeeks: ln,
  addYears: he,
  differenceInCalendarDays: Ie,
  differenceInCalendarMonths: mn,
  endOfISOWeek: yn,
  endOfMonth: bn,
  endOfWeek: Re,
  endOfYear: wn,
  format: J,
  getISOWeek: Xe,
  getWeek: Ve,
  isAfter: yr,
  isBefore: br,
  isDate: Je,
  isSameDay: wr,
  isSameMonth: Mr,
  isSameYear: kr,
  max: Dr,
  min: Or,
  setMonth: Nr,
  setYear: vr,
  startOfDay: se,
  startOfISOWeek: ie,
  startOfMonth: xr,
  startOfWeek: ee,
  startOfYear: Le
};
function Sr(e) {
  return {
    ...A,
    ...e
  };
}
function Pr() {
  const e = {};
  for (const t in k)
    e[k[t]] = `rdp-${k[t]}`;
  for (const t in x)
    e[x[t]] = `rdp-${x[t]}`;
  for (const t in _)
    e[_[t]] = `rdp-${_[t]}`;
  return e;
}
function Ke(e, t, n = A) {
  return n.format(e, "LLLL y", t);
}
const Yr = Ke;
function Cr(e, t, n = A) {
  return n.format(e, "d", t);
}
function Er(e, t = Ge) {
  var n;
  return (n = t.localize) == null ? void 0 : n.month(e);
}
function Tr(e) {
  return e < 10 ? `0${e.toLocaleString()}` : `${e.toLocaleString()}`;
}
function _r() {
  return "";
}
function Fr(e, t, n = A) {
  return n.format(e, "cccccc", t);
}
function Ze(e) {
  return e.toString();
}
const pr = Ze, Br = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Ke,
  formatDay: Cr,
  formatMonthCaption: Yr,
  formatMonthDropdown: Er,
  formatWeekNumber: Tr,
  formatWeekNumberHeader: _r,
  formatWeekdayName: Fr,
  formatYearCaption: pr,
  formatYearDropdown: Ze
}, Symbol.toStringTag, { value: "Module" }));
function jr(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...Br,
    ...e
  };
}
function qr(e, t, n, r, a, o) {
  if (!t || !n)
    return;
  const { addMonths: s, startOfMonth: i, isBefore: u, Date: d } = o, l = e.getFullYear(), m = [];
  let y = t;
  for (; m.length < 12 && u(y, s(n, 1)); )
    m.push(y.getMonth()), y = s(y, 1);
  return m.sort((b, f) => b - f).map((b) => {
    const f = r.formatMonthDropdown(b, a), w = t && new d(l, b) < i(t) || n && new d(l, b) > i(n) || !1;
    return { value: b, label: f, disabled: w };
  });
}
function Hr(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[k.Day] };
  return Object.entries(e).filter(([, a]) => a === !0).forEach(([a]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[a]
    };
  }), r;
}
function Ar(e, t, n, r = A) {
  const a = n ? r.startOfISOWeek(new r.Date()) : r.startOfWeek(new r.Date(), { locale: e, weekStartsOn: t }), o = [];
  for (let s = 0; s < 7; s++) {
    const i = r.addDays(a, s);
    o.push(i);
  }
  return o;
}
function Ir(e, t, n, r, a) {
  if (!t || !n)
    return;
  const { startOfMonth: o, startOfYear: s, endOfYear: i, addYears: u, isBefore: d, isSameYear: l, Date: m } = a, y = e.getMonth(), M = s(t), g = i(n), b = [];
  let f = M;
  for (; d(f, g) || l(f, g); )
    b.push(f.getFullYear()), f = u(f, 1);
  return b.map((w) => {
    const D = t && new m(w, y) < o(t) || y && n && new m(w, y) > o(n) || !1, c = r.formatYearDropdown(w);
    return {
      value: w,
      label: c,
      disabled: D
    };
  });
}
function Ue(e, t, n = A) {
  return n.format(e, "LLLL y", t);
}
const Rr = Ue;
function Gr(e, t, n, r = A) {
  let a = r.format(e, "PPPP", n);
  return t != null && t.today && (a = `Today, ${a}`), a;
}
function et(e, t, n, r = A) {
  let a = r.format(e, "PPPP", n);
  return t.today && (a = `Today, ${a}`), t.selected && (a = `${a}, selected`), a;
}
const Lr = et;
function Qr() {
  return "";
}
function Xr(e) {
  return "Choose the Month";
}
function $r(e, t) {
  return "Go to the Next Month";
}
function Vr(e, t) {
  return "Go to the Previous Month";
}
function zr(e, t, n = A) {
  return n.format(e, "cccc", t);
}
function Jr(e, t) {
  return `Week ${e}`;
}
function Kr(e) {
  return "Week Number";
}
function Zr(e) {
  return "Choose the Year";
}
const Ur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Rr,
  labelDay: Lr,
  labelDayButton: et,
  labelGrid: Ue,
  labelGridcell: Gr,
  labelMonthDropdown: Xr,
  labelNav: Qr,
  labelNext: $r,
  labelPrevious: Vr,
  labelWeekNumber: Jr,
  labelWeekNumberHeader: Kr,
  labelWeekday: zr,
  labelYearDropdown: Zr
}, Symbol.toStringTag, { value: "Module" })), ea = 42;
function ta(e, t, n, r) {
  const a = e[0], o = e[e.length - 1], { ISOWeek: s, fixedWeeks: i, locale: u, weekStartsOn: d } = n ?? {}, { startOfWeek: l, endOfWeek: m, startOfISOWeek: y, endOfISOWeek: M, addDays: g, differenceInCalendarDays: b, differenceInCalendarMonths: f, isAfter: w, endOfMonth: D, Date: c } = r, W = s ? y(a) : l(a, {
    weekStartsOn: d,
    locale: u
  }), S = s ? M(D(o)) : m(D(o), {
    weekStartsOn: d,
    locale: u
  }), P = b(S, W), C = f(o, a) + 1, E = [];
  for (let H = 0; H <= P; H++) {
    const L = g(W, H);
    if (t && w(L, t))
      break;
    E.push(new c(L));
  }
  const q = ea * C;
  if (i && E.length < q)
    for (let H = 0; H < 7; H++) {
      const L = g(E[E.length - 1], 1);
      E.push(new c(L));
    }
  return E;
}
function na(e) {
  const t = [];
  return e.reduce((n, r) => {
    const a = [], o = r.weeks.reduce((s, i) => [...s, ...i.days], a);
    return [...n, ...o];
  }, t);
}
function ra(e, t, n, r) {
  const { numberOfMonths: a = 1 } = n, o = [];
  for (let s = 0; s < a; s++) {
    const i = r.addMonths(e, s);
    if (t && i > t)
      break;
    o.push(i);
  }
  return o;
}
function aa(e, t) {
  const { month: n, defaultMonth: r, today: a = new t.Date(), numberOfMonths: o = 1, endMonth: s, startMonth: i } = e;
  let u = n || r || a;
  const { differenceInCalendarMonths: d, addMonths: l, startOfMonth: m } = t;
  if (s && d(s, u) < 0) {
    const y = -1 * (o - 1);
    u = l(s, y);
  }
  return i && d(u, i) < 0 && (u = i), m(u);
}
class tt {
  constructor(t, n, r = A) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class oa {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class sa {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function ia(e, t, n, r) {
  const { startOfWeek: a, endOfWeek: o, startOfISOWeek: s, endOfISOWeek: i, endOfMonth: u, addDays: d, getWeek: l, getISOWeek: m } = r, y = e.reduce((M, g) => {
    const b = n.ISOWeek ? s(g) : a(g, {
      locale: n.locale,
      weekStartsOn: n.weekStartsOn
    }), f = n.ISOWeek ? i(u(g)) : o(u(g), {
      locale: n.locale,
      weekStartsOn: n.weekStartsOn
    }), w = t.filter((W) => W >= b && W <= f);
    if (n.fixedWeeks && w.length < 42) {
      const W = t.filter((S) => S > f && S <= d(f, 7));
      w.push(...W);
    }
    const D = w.reduce((W, S) => {
      const P = n.ISOWeek ? m(S) : l(S, {
        locale: n.locale,
        weekStartsOn: n.weekStartsOn,
        firstWeekContainsDate: n.firstWeekContainsDate
      }), C = W.find((q) => q.weekNumber === P), E = new tt(S, g, r);
      return C ? C.days.push(E) : W.push(new sa(P, [E])), W;
    }, []), c = new oa(g, D);
    return M.push(c), M;
  }, []);
  return n.reverseMonths ? y.reverse() : y;
}
function ca(e, t) {
  var f;
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: a, startOfDay: o, startOfMonth: s, endOfMonth: i, addYears: u, endOfYear: d, Date: l } = t, { fromYear: m, toYear: y, fromMonth: M, toMonth: g } = e;
  !n && M && (n = M), !n && m && (n = new l(m, 0, 1)), !r && g && (r = g), !r && y && (r = new l(y, 11, 31));
  const b = (f = e.captionLayout) == null ? void 0 : f.startsWith("dropdown");
  return n ? n = s(n) : m ? n = new l(m, 0, 1) : !n && b && (n = a(u(e.today ?? new l(), -100))), r ? r = i(r) : y ? r = new l(y, 11, 31) : !r && b && (r = d(e.today ?? new l())), [
    n && o(n),
    r && o(r)
  ];
}
function ua(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: a, numberOfMonths: o = 1 } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: u } = r, d = a ? o : 1, l = s(e);
  if (!t)
    return i(l, d);
  if (!(u(t, e) < o))
    return i(l, d);
}
function da(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: a, numberOfMonths: o } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: u } = r, d = a ? o ?? 1 : 1, l = s(e);
  if (!t)
    return i(l, -d);
  if (!(u(l, t) <= 0))
    return i(l, -d);
}
function fa(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function la(e, t) {
  const [n, r] = le(e);
  return [t === void 0 ? n : t, r];
}
function ha(e, t) {
  const [n, r] = ca(e, t), { startOfMonth: a, endOfMonth: o } = t, s = aa(e, t), [i, u] = la(s, e.month ? a(e.month) : void 0), d = ra(i, r, e, t), l = ta(d, e.endMonth ? o(e.endMonth) : void 0, e, t), m = ia(d, l, e, t), y = fa(m), M = na(m), g = da(i, n, e, t), b = ua(i, r, e, t), { disableNavigation: f, onMonthChange: w } = e, D = (P) => y.some((C) => C.days.some((E) => E.isEqualTo(P))), c = (P) => {
    if (f)
      return;
    let C = a(P);
    n && C < a(n) && (C = a(n)), r && C > a(r) && (C = a(r)), u(C), w == null || w(C);
  };
  return {
    months: m,
    weeks: y,
    days: M,
    navStart: n,
    navEnd: r,
    previousMonth: g,
    nextMonth: b,
    goToMonth: c,
    goToDay: (P) => {
      D(P) || c(P.date);
    }
  };
}
const ma = Bt(void 0);
function ga(e, t, n, r) {
  let a, o = 0, s = !1;
  for (; o < e.length && !s; ) {
    const i = e[o], u = t(i);
    !u[x.disabled] && !u[x.hidden] && !u[x.outside] && (u[x.focused] || r != null && r.isEqualTo(i) || n(i.date) || u[x.today]) && (a = i, s = !0), o++;
  }
  return a || (a = e.find((i) => {
    const u = t(i);
    return !u[x.disabled] && !u[x.hidden] && !u[x.outside];
  })), a;
}
function ve(e, t, n = !1, r = A) {
  let { from: a, to: o } = e;
  const { differenceInCalendarDays: s, isSameDay: i } = r;
  return a && o ? (s(o, a) < 0 && ([a, o] = [o, a]), s(t, a) >= (n ? 1 : 0) && s(o, t) >= (n ? 1 : 0)) : !n && o ? i(o, t) : !n && a ? i(a, t) : !1;
}
function ya(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function nt(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function ba(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function wa(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Ma(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function ka(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function U(e, t, n) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: a, differenceInCalendarDays: o, isAfter: s } = n;
  return r.some((i) => {
    if (typeof i == "boolean")
      return i;
    if (n.isDate(i))
      return a(e, i);
    if (ka(i, n))
      return i.includes(e);
    if (nt(i))
      return ve(i, e, !1, n);
    if (Ma(i))
      return Array.isArray(i.dayOfWeek) ? i.dayOfWeek.includes(e.getDay()) : i.dayOfWeek === e.getDay();
    if (ya(i)) {
      const u = o(i.before, e), d = o(i.after, e), l = u > 0, m = d < 0;
      return s(i.before, i.after) ? m && l : l || m;
    }
    return ba(i) ? o(e, i.after) > 0 : wa(i) ? o(i.before, e) > 0 : typeof i == "function" ? i(e) : !1;
  });
}
function Da(e, t, n, r, a, o, s) {
  const { weekStartsOn: i, locale: u, ISOWeek: d } = o, { addDays: l, addMonths: m, addYears: y, addWeeks: M, startOfISOWeek: g, endOfISOWeek: b, startOfWeek: f, endOfWeek: w, max: D, min: c } = s;
  let S = {
    day: l,
    week: M,
    month: m,
    year: y,
    startOfWeek: (P) => d ? g(P) : f(P, { locale: u, weekStartsOn: i }),
    endOfWeek: (P) => d ? b(P) : w(P, { locale: u, weekStartsOn: i })
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? S = D([r, S]) : t === "after" && a && (S = c([a, S])), S;
}
function rt(e, t, n, r, a, o, s, i = 0) {
  if (i > 365)
    return;
  const u = Da(
    e,
    t,
    n.date,
    // should be refDay? or refDay.date?
    r,
    a,
    o,
    s
  ), d = !!(o.disabled && U(u, o.disabled, s)), l = !!(o.hidden && U(u, o.hidden, s)), m = u, y = new tt(u, m, s);
  return !d && !l ? y : rt(e, t, y, r, a, o, s, i + 1);
}
function Oa(e, t, n, r, a) {
  const { autoFocus: o } = e, [s, i] = le(), u = ga(t.days, n, r || (() => !1), s), [d, l] = le(o ? u : void 0);
  return {
    isFocusTarget: (b) => !!(u != null && u.isEqualTo(b)),
    setFocused: l,
    focused: d,
    blur: () => {
      i(d), l(void 0);
    },
    moveFocus: (b, f) => {
      if (!d)
        return;
      const w = rt(b, f, d, t.navStart, t.navEnd, e, a);
      w && (t.goToDay(w), l(w));
    }
  };
}
function Wa(e, t, n) {
  const { disabled: r, hidden: a, modifiers: o, showOutsideDays: s, today: i } = t, { isSameDay: u, isSameMonth: d, Date: l } = n, m = {
    [x.focused]: [],
    [x.outside]: [],
    [x.disabled]: [],
    [x.hidden]: [],
    [x.today]: []
  }, y = {}, M = {
    [_.range_end]: [],
    [_.range_middle]: [],
    [_.range_start]: [],
    [_.selected]: []
  };
  for (const g of e) {
    const { date: b, displayMonth: f } = g, w = !!(f && !d(b, f)), D = !!(r && U(b, r, n)), c = !!(a && U(b, a, n)) || !s && w, W = u(b, i ?? new l());
    w && m.outside.push(g), D && m.disabled.push(g), c && m.hidden.push(g), W && m.today.push(g), o && Object.keys(o).forEach((S) => {
      const P = o == null ? void 0 : o[S];
      P && U(b, P, n) && (y[S] ? y[S].push(g) : y[S] = [g]);
    });
  }
  return (g) => {
    const b = {
      [x.focused]: !1,
      [x.disabled]: !1,
      [x.hidden]: !1,
      [x.outside]: !1,
      [x.today]: !1
    }, f = {
      [_.range_end]: !1,
      [_.range_middle]: !1,
      [_.range_start]: !1,
      [_.selected]: !1
    }, w = {};
    for (const D in m) {
      const c = m[D];
      b[D] = c.some((W) => W === g);
    }
    for (const D in M) {
      const c = M[D];
      f[D] = c.some((W) => W === g);
    }
    for (const D in y)
      w[D] = y[D].some((c) => c === g);
    return {
      ...f,
      ...b,
      // custom modifiers should override all the previous ones
      ...w
    };
  };
}
function Na(e, t) {
  const { selected: n, required: r, onSelect: a, mode: o } = e, [s, i] = h.useState(n), { isSameDay: u, Date: d } = t;
  h.useEffect(() => {
    r && s === void 0 && i([new d()]);
  }, [r, s, d, o]), h.useEffect(() => {
    i(n);
  }, [o, n]);
  const l = (g) => (s == null ? void 0 : s.some((b) => u(b, g))) ?? !1, { min: m, max: y } = e;
  return {
    selected: s,
    select: (g, b, f) => {
      let w = [...s ?? []];
      if (l(g)) {
        if ((s == null ? void 0 : s.length) === m || r && (s == null ? void 0 : s.length) === 1)
          return;
        w = s == null ? void 0 : s.filter((D) => !u(D, g));
      } else
        (s == null ? void 0 : s.length) === y ? w = [g] : w = [...w, g];
      return a == null || a(w, g, b, f), i(w), w;
    },
    isSelected: l
  };
}
function va(e, t, n = A) {
  const { from: r, to: a } = t || {}, { isSameDay: o, isAfter: s, isBefore: i } = n;
  return r && a ? o(a, e) && o(r, e) ? { from: void 0, to: void 0 } : o(a, e) ? { from: a, to: void 0 } : o(r, e) ? { from: void 0, to: void 0 } : s(r, e) ? { from: e, to: a } : { from: r, to: e } : a ? s(e, a) ? { from: a, to: e } : { from: e, to: a } : r ? i(e, r) ? { from: e, to: r } : o(e, r) ? { from: void 0, to: void 0 } : { from: r, to: e } : { from: e, to: void 0 };
}
function xa(e, t) {
  const { mode: n, disabled: r, excludeDisabled: a, selected: o, required: s, onSelect: i } = e, { differenceInCalendarDays: u } = t, [d, l] = h.useState(o);
  return h.useEffect(() => {
    s && d === void 0 && l({ from: void 0, to: void 0 });
  }, [s, d, n]), h.useEffect(() => {
    l(o);
  }, [o]), {
    selected: d,
    select: (M, g, b) => {
      const f = M ? va(M, d, t) : void 0, { min: w, max: D } = e;
      if (w && f != null && f.from && f.to && u(f.to, f.from) < w - 1 && (f.from = M, f.to = void 0), D && f != null && f.from && f.to && u(f.to, f.from) >= D && (f.from = M, f.to = void 0), f != null && f.from && f.to) {
        let c = f.from;
        for (; t.differenceInCalendarDays(f.to, c) > 0; )
          if (c = t.addDays(c, 1), a && r && U(c, r, t)) {
            f.from = M, f.to = void 0;
            break;
          }
      }
      return l(f), i == null || i(f, M, g, b), f;
    },
    isSelected: (M) => d && ve(d, M, !1, t)
  };
}
function Sa(e, t) {
  const { selected: n, required: r, onSelect: a, mode: o } = e, [s, i] = h.useState(n), { isSameDay: u, Date: d, startOfDay: l } = t;
  return h.useEffect(() => {
    r && s === void 0 && i(l(new d()));
  }, [r, s, d, l, o]), h.useEffect(() => {
    i(n);
  }, [n]), {
    selected: s,
    select: (M, g, b) => {
      let f = M;
      return !r && s && s && u(M, s) && (f = void 0), i(f), a == null || a(f, M, g, b), f;
    },
    isSelected: (M) => s ? u(s, M) : !1
  };
}
function Pa(e, t) {
  const n = Sa(e, t), r = Na(e, t), a = xa(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return a;
    default:
      return;
  }
}
function Ya(e) {
  const { components: t, formatters: n, labels: r, dateLib: a, classNames: o } = We(() => ({
    dateLib: Sr(e.dateLib),
    components: dn(e.components),
    formatters: jr(e.formatters),
    labels: { ...Ur, ...e.labels },
    classNames: { ...Pr(), ...e.classNames }
  }), [
    e.classNames,
    e.components,
    e.dateLib,
    e.formatters,
    e.labels
  ]), { captionLayout: s, firstWeekContainsDate: i, locale: u, mode: d, onDayBlur: l, onDayClick: m, onDayFocus: y, onDayKeyDown: M, onDayMouseEnter: g, onDayMouseLeave: b, onNextClick: f, onPrevClick: w, showWeekNumber: D, styles: c, useAdditionalDayOfYearTokens: W, useAdditionalWeekYearTokens: S, weekStartsOn: P } = e, C = {
    locale: u,
    weekStartsOn: P,
    firstWeekContainsDate: i,
    useAdditionalWeekYearTokens: S,
    useAdditionalDayOfYearTokens: W
  }, E = C, { formatCaption: q, formatDay: H, formatMonthDropdown: L, formatWeekNumber: me, formatWeekNumberHeader: ge, formatWeekdayName: at, formatYearDropdown: ot } = n, xe = ha(e, a), { days: st, months: ye, navStart: Se, navEnd: Pe, previousMonth: R, nextMonth: Q, goToMonth: V } = xe, be = Wa(st, e, a), { isSelected: te, select: ne, selected: ue } = Pa(e, a) ?? {}, { blur: Ye, focused: we, isFocusTarget: it, moveFocus: Ce, setFocused: de } = Oa(e, xe, be, te ?? (() => !1), a), { labelDayButton: ct, labelGridcell: ut, labelGrid: dt, labelMonthDropdown: ft, labelNav: lt, labelNext: ht, labelPrevious: mt, labelWeekday: gt, labelWeekNumber: yt, labelWeekNumberHeader: bt, labelYearDropdown: wt } = r, Mt = We(() => Ar(u, e.weekStartsOn, e.ISOWeek, a), [a, u, e.ISOWeek, e.weekStartsOn]), Ee = d !== void 0 || m !== void 0, kt = X(() => {
    R && (V(R), w == null || w(R));
  }, [R, V, w]), Dt = X(() => {
    Q && (V(Q), f == null || f(Q));
  }, [V, Q, f]), Ot = X((v, p) => (T) => {
    T.preventDefault(), T.stopPropagation(), de(v), ne == null || ne(v.date, p, T), m == null || m(v.date, p, T);
  }, [ne, m, de]), Wt = X((v, p) => (T) => {
    de(v), y == null || y(v.date, p, T);
  }, [y, de]), Nt = X((v, p) => (T) => {
    Ye(), l == null || l(v.date, p, T);
  }, [Ye, l]), vt = X((v, p) => (T) => {
    const fe = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [T.shiftKey ? "year" : "month", "before"],
      PageDown: [T.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (fe[T.key]) {
      T.preventDefault(), T.stopPropagation();
      const [Me, ke] = fe[T.key];
      Ce(Me, ke);
    }
    M == null || M(v.date, p, T);
  }, [Ce, M, e.dir]), xt = X((v, p) => (T) => {
    g == null || g(v.date, p, T);
  }, [g]), St = X((v, p) => (T) => {
    b == null || b(v.date, p, T);
  }, [b]), { className: Pt, style: Yt } = We(() => ({
    className: [o[k.Root], e.className].filter(Boolean).join(" "),
    style: { ...c == null ? void 0 : c[k.Root], ...e.style }
  }), [o, e.className, e.style, c]), Ct = fn(e), Et = {
    selected: ue,
    select: ne,
    isSelected: te,
    months: ye,
    nextMonth: Q,
    previousMonth: R,
    goToMonth: V,
    getModifiers: be
  };
  return h.createElement(
    ma.Provider,
    { value: Et },
    h.createElement(
      t.Root,
      { className: Pt, style: Yt, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, ...Ct },
      h.createElement(
        t.Months,
        { className: o[k.Months], style: c == null ? void 0 : c[k.Months] },
        !e.hideNavigation && h.createElement(
          t.Nav,
          { role: "navigation", className: o[k.Nav], style: c == null ? void 0 : c[k.Nav], "aria-label": lt() },
          h.createElement(
            t.Button,
            { type: "button", className: o[k.ButtonPrevious], tabIndex: R ? void 0 : -1, disabled: R ? void 0 : !0, "aria-label": mt(R, E), onClick: kt },
            h.createElement(t.Chevron, { disabled: R ? void 0 : !0, className: o[k.Chevron], orientation: "left" })
          ),
          h.createElement(
            t.Button,
            { type: "button", className: o[k.ButtonNext], tabIndex: Q ? void 0 : -1, disabled: Q ? void 0 : !0, "aria-label": ht(Q, E), onClick: Dt },
            h.createElement(t.Chevron, { disabled: R ? void 0 : !0, orientation: "right", className: o[k.Chevron] })
          )
        ),
        ye.map((v, p) => {
          const T = (B) => {
            const K = Number(B.target.value), F = a.setMonth(a.startOfMonth(v.date), K);
            V(F);
          }, fe = (B) => {
            const K = a.setYear(a.startOfMonth(v.date), Number(B.target.value));
            V(K);
          }, Me = qr(v.date, Se, Pe, n, u, a), ke = Ir(ye[0].date, Se, Pe, n, a);
          return h.createElement(
            t.Month,
            { className: o[k.Month], style: c == null ? void 0 : c[k.Month], key: p, displayIndex: p, calendarMonth: v },
            h.createElement(t.MonthCaption, { className: o[k.MonthCaption], style: c == null ? void 0 : c[k.MonthCaption], calendarMonth: v, displayIndex: p }, s != null && s.startsWith("dropdown") ? h.createElement(
              t.DropdownNav,
              { className: o[k.Dropdowns], style: c == null ? void 0 : c[k.Dropdowns] },
              s === "dropdown" || s === "dropdown-months" ? h.createElement(t.Dropdown, { "aria-label": ft(), classNames: o, components: t, disabled: !!e.disableNavigation, onChange: T, options: Me, style: c == null ? void 0 : c[k.Dropdown], value: v.date.getMonth() }) : h.createElement("span", { role: "status", "aria-live": "polite" }, L(v.date.getMonth())),
              s === "dropdown" || s === "dropdown-years" ? h.createElement(t.Dropdown, { "aria-label": wt(E), classNames: o, components: t, disabled: !!e.disableNavigation, onChange: fe, options: ke, style: c == null ? void 0 : c[k.Dropdown], value: v.date.getFullYear() }) : h.createElement("span", { role: "status", "aria-live": "polite" }, ot(v.date.getFullYear()))
            ) : h.createElement(t.CaptionLabel, { className: o[k.CaptionLabel], role: "status", "aria-live": "polite" }, q(v.date, C, a))),
            h.createElement(
              t.MonthGrid,
              { role: "grid", "aria-multiselectable": d === "multiple" || d === "range", "aria-label": dt(v.date, E, a) || void 0, className: o[k.MonthGrid], style: c == null ? void 0 : c[k.MonthGrid] },
              !e.hideWeekdays && h.createElement(
                t.Weekdays,
                { className: o[k.Weekdays], role: "row", style: c == null ? void 0 : c[k.Weekdays] },
                D && h.createElement(t.WeekNumberHeader, { "aria-label": bt(E), className: o[k.WeekNumberHeader], role: "columnheader", style: c == null ? void 0 : c[k.WeekNumberHeader] }, ge()),
                Mt.map((B, K) => h.createElement(t.Weekday, { "aria-label": gt(B, E, a), className: o[k.Weekday], key: K, role: "columnheader", style: c == null ? void 0 : c[k.Weekday] }, at(B, C, a)))
              ),
              h.createElement(t.Weeks, { className: o[k.Weeks], role: "rowgroup", style: c == null ? void 0 : c[k.Weeks] }, v.weeks.map((B, K) => h.createElement(
                t.Week,
                { className: o[k.Week], key: B.weekNumber, role: "row", style: c == null ? void 0 : c[k.Week], week: B },
                D && h.createElement(t.WeekNumber, { week: B, role: "rowheader", style: c == null ? void 0 : c[k.WeekNumber], "aria-label": yt(B.weekNumber, {
                  locale: u
                }), className: o[k.WeekNumber] }, me(B.weekNumber)),
                B.days.map((F) => {
                  const { date: G } = F, Y = be(F);
                  if (Y[x.focused] = !Y.hidden && !!(we != null && we.isEqualTo(F)), Y[_.selected] = !Y.disabled && ((te == null ? void 0 : te(G)) || Y.selected), nt(ue)) {
                    const { from: De, to: Oe } = ue;
                    Y[_.range_start] = !!(De && Oe && a.isSameDay(G, De)), Y[_.range_end] = !!(De && Oe && a.isSameDay(G, Oe)), Y[_.range_middle] = ve(ue, G, !0, a);
                  }
                  const Tt = Hr(Y, c, e.modifiersStyles), _t = Ht(Y, o, e.modifiersClassNames), Ft = Ee ? void 0 : ut(G, Y, E, a), pt = {
                    "data-day": a.format(G, "yyyy-MM-dd"),
                    "data-month": F.outside ? a.format(G, "yyyy-MM") : void 0
                  };
                  return h.createElement(t.Day, { key: `${a.format(G, "yyyy-MM-dd")}_${a.format(F.displayMonth, "yyyy-MM")}`, day: F, modifiers: Y, role: "gridcell", className: _t.join(" "), style: Tt, "aria-hidden": Y.hidden || void 0, "aria-selected": Y.selected || void 0, "aria-label": Ft, ...pt }, Ee ? h.createElement(t.DayButton, { className: o[k.DayButton], style: c == null ? void 0 : c[k.DayButton], day: F, modifiers: Y, disabled: Y.disabled || void 0, tabIndex: it(F) ? 0 : -1, "aria-label": ct(G, Y, E, a), onClick: Ot(F, Y), onBlur: Nt(F, Y), onFocus: Wt(F, Y), onKeyDown: vt(F, Y), onMouseEnter: xt(F, Y), onMouseLeave: St(F, Y) }, H(G, C, a)) : H(F.date, C, a));
                })
              )))
            )
          );
        })
      ),
      e.footer && h.createElement(t.Footer, { className: o[k.Footer], style: c == null ? void 0 : c[k.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function Ca(e, t) {
  return oe(e, -t);
}
function Ea(e, t) {
  return he(e, -t);
}
const Ta = {
  day: "cur-p-0",
  day_button: "cur-w-10 cur-h-10 cur-flex cur-items-center cur-justify-center cur-cursor-pointer hover:cur-bg-surface-highlight-hover",
  disabled: "cur-bg-surface-disabled !cur-text-disabled hover:cur-bg-surface-disabled hover:cur-cursor-not-allowed",
  months: "cur-flex cur-justify-center",
  outside: "cur-pointer-none cur-invisible",
  range_middle: "[&>button]:cur-text-primary [&>button]:cur-bg-surface-highlight [&>button]:hover:!cur-bg-surface-highlight-hover",
  selected: "[&>button]:cur-bg-surface-brand [&>button]:cur-text-inverse [&>button]:hover:!cur-bg-surface-brand",
  today: "[&>button]:cur-border [&>button]:cur-border-brand [&>button]:cur-text-brand",
  week: "cur-flex",
  weeks: "cur-flex cur-gap-2 cur-flex-col",
  weekday: "cur-w-10 cur-h-10 cur-flex cur-items-center cur-justify-center cur-font-normal",
  weekdays: "cur-flex"
}, qe = ({
  children: e,
  className: t,
  decLabel: n,
  denomination: r,
  incLabel: a,
  mutator: o
}) => /* @__PURE__ */ I.jsxs(
  "div",
  {
    title: `Select ${r}`,
    className: qt("cur-flex cur-items-center cur-gap-1", t),
    children: [
      /* @__PURE__ */ I.jsx("button", { title: n, onClick: () => o(-1), className: "cur-p-2", children: /* @__PURE__ */ I.jsx(Te, { size: "sm", className: "cur-rotate-180" }) }),
      e,
      /* @__PURE__ */ I.jsx("button", { title: a, onClick: () => o(1), className: "cur-p-2", children: /* @__PURE__ */ I.jsx(Te, { size: "sm" }) })
    ]
  }
), _a = ({
  children: e,
  className: t,
  classNames: n,
  components: r,
  defaultMonth: a,
  disabled: o,
  formatters: s,
  fromDate: i,
  fromYear: u,
  hidden: d,
  hideNavigation: l,
  labels: m,
  mode: y = "single",
  modifiers: M,
  month: g,
  onMonthChange: b,
  required: f = !1,
  ...w
}) => {
  const [D, c] = le(
    g || a || /* @__PURE__ */ new Date()
  );
  jt(() => {
    g && c(g);
  }, [g]);
  let W = {
    onMonthChange: b,
    formatters: s,
    labels: m,
    modifiers: M,
    mode: y,
    disabled: o,
    fromDate: i,
    fromYear: u,
    hidden: d,
    hideNavigation: l || !0,
    classNames: {
      ...Ta,
      ...n || {}
    },
    components: {
      MonthCaption: (E) => {
        const q = E.calendarMonth.date, H = (L) => (me) => c((ge) => L(ge, me));
        return /* @__PURE__ */ I.jsxs("div", { className: "cur-flex cur-h-12 cur-justify-around", children: [
          /* @__PURE__ */ I.jsx(
            qe,
            {
              className: "cur-grow cur-basis-full",
              decLabel: `Switch to ${J(Ca(q, 1), "MMMM")}`,
              denomination: "month",
              incLabel: `Switch to ${J(oe(q, 1), "MMMM")}`,
              mutator: H(oe),
              children: /* @__PURE__ */ I.jsx("span", { className: "cur-grow cur-basis-full cur-text-center", children: J(q, "MMMM") })
            }
          ),
          /* @__PURE__ */ I.jsx(
            qe,
            {
              className: "cur-grow",
              decLabel: `Switch to ${J(Ea(q, 1), "yyyy")}`,
              denomination: "year",
              incLabel: `Switch to ${J(he(q, 1), "yyyy")}`,
              mutator: H(he),
              children: J(q, "yyyy")
            }
          )
        ] });
      },
      ...r
    }
  };
  const { onSelect: S, selected: P, ...C } = w;
  return W = {
    ...W,
    onSelect: S,
    required: f,
    selected: P
  }, /* @__PURE__ */ I.jsxs("div", { className: t, ...C, children: [
    /* @__PURE__ */ I.jsx(Ya, { month: D, ...W }),
    e
  ] });
};
_a.displayName = "DatePicker";
export {
  _a as DatePicker
};
//# sourceMappingURL=index.js.map
